import "./NoxControl.module.css";
import Header from "@/reusable_sections/Header";
import NoxHero from "./sections/NoxHero";
import NoxControl from "./sections/NoxControl";
import Noxbenefits from "./sections/Noxbenefits";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function NoxControlPage() {
  return <div>
      <Header />
      <NoxHero />
      <NoxControl />
      <Noxbenefits />
      <CallToAction />
      <Footer />
    </div>;
}